export default "/images/vendor/flag-icons/flags/4x3/gy.svg?80b47cd2f50d288d53b6ece569f43488";